import { useEffect } from "react";
import ChatBox from "./Components/ChatBox";

function App() {
  
  return (
    <div className="App">
      <ChatBox/>
    </div>
  );
}

export default App;
